import { Button } from "@mui/material"

export const NotAuthorized = () => {
    return (
        <div style={{
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center", 
            justifyContent: "center", 
            height: "100vh"
        }}>
            <h1>You don't have access to this page</h1>
            <p>Please contact your administrator to get access</p>
            {/* add go login button */}
            <Button variant="contained" color="primary" onClick={() => window.location.href = "/signin"}>Go Signin</Button>
        </div>
    )
}